"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
function useAuto(cb, timeout) {
    const timerID = (0, react_1.useRef)(undefined);
    const cbRef = (0, react_1.useRef)(cb);
    const triggerRef = (0, react_1.useRef)(noop_1.default);
    cbRef.current = cb;
    const auto = (0, react_1.useMemo)(() => {
        function cleanup() {
            clearTimeout(timerID.current);
            timerID.current = undefined;
        }
        function start() {
            if (!timeout)
                return;
            timerID.current = setTimeout(triggerRef.current, timeout);
            return cleanup;
        }
        triggerRef.current = () => {
            if (!timeout)
                return;
            const result = cbRef.current();
            if (typeof result === 'object') {
                result.then(start);
            }
            else {
                start();
            }
        };
        return {
            cleanup,
            start,
            trigger: triggerRef.current,
            stop: cleanup,
        };
    }, [timeout]);
    (0, react_1.useEffect)(function autoEffect() {
        return auto.start();
    }, [auto]);
    return auto;
}
exports.default = useAuto;
//# sourceMappingURL=useAuto.js.map